import { useState } from "react";
import { IconButton, Link, Tooltip, Typography } from "@mui/joy";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useTranslation } from "../i18n";
import OpenInNewRounded from "@mui/icons-material/OpenInNewRounded";
import { Link as RouterLink } from "react-router-dom";

export interface ContactRefProps {
  contactRef: string;
  teamSlug: string;
  openInNewWindow?: boolean;
  copy?: boolean;
}

export default function ContactRef({
  contactRef,
  teamSlug,
  openInNewWindow,
  copy,
}: ContactRefProps) {
  const t = useTranslation();
  const [copied, setCopied] = useState<string | null>(null);
  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(contactRef);
    setCopied(contactRef);
    setTimeout(() => setCopied(null), 200);
  };
  const short =
    contactRef.slice(0, 3) +
    ".." +
    contactRef.slice(contactRef.length - 3, contactRef.length);
  return (
    <Typography
      sx={{ display: "unset" }}
      fontSize={12}
      startDecorator={
        copy && (
          <Tooltip arrow title={<Typography>{t("Copy Ref #")}</Typography>}>
            <IconButton
              size="sm"
              variant={copied === contactRef ? "solid" : "plain"}
              color={copied === contactRef ? "success" : "neutral"}
              onClick={handleCopyToClipboard}
            >
              <ContentCopyIcon />
            </IconButton>
          </Tooltip>
        )
      }
    >
      <Link
        sx={{ fontFamily: "monospace" }}
        component={RouterLink}
        to={`/${teamSlug}/contacts/${contactRef}`}
        target={openInNewWindow ? "_blank" : ""}
        endDecorator={openInNewWindow ? <OpenInNewRounded /> : null}
      >
        {short.toUpperCase()}
      </Link>
    </Typography>
  );
}
